import { Component, computed, Inject, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Predmet } from '../model/predmet';
import { TranslateService } from '@ngx-translate/core';
import { AppStateService } from '../app-state.service';
import { MatCheckboxChange } from '@angular/material/checkbox';

export interface ZabezpecovanePredmetyDialogData {
  idTypZaznamu: number;
  maxPocetPredmetov: number;
  kodJazykFormulara: string;
}

@Component({
  selector: 'app-profilove-a-ostatne-zabezpecovane-predmety-dialog',
  standalone: false,
  templateUrl: './profilove-a-ostatne-zabezpecovane-predmety-dialog.component.html',
  styleUrl: './profilove-a-ostatne-zabezpecovane-predmety-dialog.component.css'
})
export class ProfiloveAOstatneZabezpecovanePredmetyDialogComponent {

  data = inject(MAT_DIALOG_DATA);
  // predmetyPole: Predmet[] = [];
  // profilovePredmetyPole: Predmet[] = [];
  // ostatnePredmetyPole: Predmet[] = [];
  // pocetChecknutychPredmetov = signal(0);

  title = '';
  akRok: string;
  akRoky: string[];
  aktualnyAkRok: string;

  typZobrazovanychDat: string;
  maxPocetPredmetov: number;
  kodJazykFormulara: string;

  readonly ID_TYP_PROFILOVE_PREDMETY = -47;
  readonly ID_TYP_OSTATNE_PREDMETY = -68;

  readonly TYP_DAT_PROFILOVE_PREDMETY = 'P';
  readonly TYP_DAT_OSTATNE_PREDMETY = 'O';

  isLoading = signal(true); // na zaciatku nacitavame data

  // Signal s predmetmi
  predmetyPole = signal<Predmet[]>([]);
  profilovePredmetyPole = signal<Predmet[]>([]);
  ostatnePredmetyPole = signal<Predmet[]>([]);

  // Reaktivne počítadlo - vypočíta sa AUTOMATICKY bez nutnosti volať metódu
  pocetChecknutychPredmetov = computed(() => {
    return this.predmetyPole().filter(p => p.vybrany).length;
  });

  // Reaktivne počítadlo - vypočíta sa AUTOMATICKY bez nutnosti volať metódu
  pocetChecknutychProfilovychAOstatnychPredmetov = computed(() => {
    const p1 = this.profilovePredmetyPole().filter(p => p.vybrany).length;
    const p2 = this.ostatnePredmetyPole().filter(p => p.vybrany).length;
    return p1 + p2;
  });


  constructor(
    public dialogRef: MatDialogRef<ProfiloveAOstatneZabezpecovanePredmetyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataMatDialog: ZabezpecovanePredmetyDialogData,
    private translateService: TranslateService,
    private appStateService: AppStateService
  ) {

  }

  ngOnInit(): void {

    const idTyp = this.dataMatDialog.idTypZaznamu;
    this.typZobrazovanychDat = this.getTypZobrazovanychDat(idTyp);
    this.maxPocetPredmetov = this.dataMatDialog.maxPocetPredmetov;
    this.kodJazykFormulara = this.dataMatDialog.kodJazykFormulara;

    this.title = this.getTitle(idTyp);

    this.akRok = this.appStateService.akRok;

    this.appStateService.akademickeRokyFetched
      .subscribe((akRoky: string[]) => {
        this.akRoky = akRoky;
        if (this.appStateService.akRok) {
          this.appStateService.fetchZabezpecovanePredmety(
            this.typZobrazovanychDat,
            this.appStateService.akRok);
        } else {
          this.appStateService.fetchAktualnyAkademickyRok();
        }
    });

    this.appStateService.aktualnyAkRokFetched
      .subscribe((aktualnyAkRok: string) => {
        this.aktualnyAkRok = aktualnyAkRok;
        this.akRok = aktualnyAkRok;

        if (this.predmetyPole().length === 0) {
          this.appStateService.fetchZabezpecovanePredmety(
            this.typZobrazovanychDat,
            this.aktualnyAkRok);
        }

      });

    this.isLoading.set(true);

    this.appStateService.zabezpecovanePredmetyFetched
      .subscribe({
        next: (predmety: Predmet[]) => {
          if (this.typZobrazovanychDat === this.TYP_DAT_PROFILOVE_PREDMETY) {
            this.predmetyPole.set(predmety.filter(predmet => predmet.profilovy));
          } else if (this.typZobrazovanychDat === this.TYP_DAT_OSTATNE_PREDMETY) {
            this.predmetyPole.set(predmety);
            this.profilovePredmetyPole.set(predmety.filter(predmet => predmet.profilovy));
            this.ostatnePredmetyPole.set(predmety.filter(predmet => !predmet.profilovy));
          }
          this.isLoading.set(false);
        },
        error: (error) => {
          console.error('Chyba načítania zabezpečovaných predmetov:', error);
          this.isLoading.set(false);
        }
      });


    this.appStateService.fetchAkademickeRoky();



  }

  onConfirm(): void {

    let oznacenePredmety = this.predmetyPole().filter(predmet => predmet.vybrany);

    if (this.typZobrazovanychDat === this.TYP_DAT_OSTATNE_PREDMETY) {

      if (oznacenePredmety.find((predmet) => predmet.profilovy)) {
        const confirmDialogRef = this.appStateService.openConfirmDialog(
          this.translateService.instant('Medzi zabezpečované predmety ste vybrali aj profilový predmet. Chcete ho zaevidovať medzi zabezpečované predmety?')
        )

        confirmDialogRef.afterClosed().subscribe(res => {
            if (res !== 'OK') {
              // Odstránime profilové predmety zo zoznamu
              oznacenePredmety = oznacenePredmety.filter(predmet => !predmet.profilovy);
            }

            if (oznacenePredmety) {
              this.dialogRef.close(oznacenePredmety);
            }

        });
      } else {
        if (oznacenePredmety) {
          this.dialogRef.close(oznacenePredmety);
        }
      }


    } else {
      if (oznacenePredmety) {
        this.dialogRef.close(oznacenePredmety);
      }
    }

  }

  getTitle(idTyp: number) : string {

    let result = '';

    if (idTyp === this.ID_TYP_PROFILOVE_PREDMETY) {
      result = this.translateService.instant('Profilové predmety');
    } else if (idTyp === this.ID_TYP_OSTATNE_PREDMETY) {
      result = this.translateService.instant('Zabezpečované predmety');
    }

    return result;

  }


  getAkademickyRokTooltip() {
    return this.translateService.instant('Akademický rok');
  }

  onAkRokComboboxChange() {

    this.isLoading.set(true);
    this.appStateService.fetchZabezpecovanePredmety(this.typZobrazovanychDat,
      this.akRok);

  }

  getTypZobrazovanychDat(idTyp: number) : string {

    if (idTyp === this.ID_TYP_PROFILOVE_PREDMETY) {
        return this.TYP_DAT_PROFILOVE_PREDMETY
    } else {
        return this.TYP_DAT_OSTATNE_PREDMETY;
    }

  }

  // checkboxChange($event: MatCheckboxChange, item: Predmet) {
  //   // $event.checked nám hovorí, či sa používateľ pokúša checkbox zaškrtnúť (true) alebo odškrtnúť (false)
  //   if ($event.checked) {

  //     // Kontrola maxima
  //     if (this.pocetChecknutychPredmetov >= this.maxPocetPredmetov) {

  //       // Keďže používame [checked]="item.isSelected", stačí, ak hodnotu v modeli NEZMENÍME.
  //       // Angular Material sám zabezpečí, že checkbox zostane ODŠKRTNUTÝ.
  //       // Netreba žiadny preventDefault() ani stopPropagation()!

  //       this.appStateService.openErrorDialog(
  //         this.translateService.instant('Maximálny počet vybraných predmetov je') + ' ' + this.maxPocetPredmetov
  //       );

  //       // Aby sa checkbox vizuálne vrátil do odškrtnutého stavu, musíme Angularu "povedať",
  //       // nech prekreslí view (vynútime reset hodnoty na false)
  //       $event.source.checked = false;
  //       return;
  //     }

  //     // Ak je všetko ok, zapíšeme stav do modelu a zvýšime počítadlo
  //     item.vybrany = true;
  //     this.pocetChecknutychPredmetov++;

  //   } else {
  //     // Ak užívateľ odškrtáva, iba znížime počítadlo a zmeníme stav v modeli
  //     item.vybrany = false;
  //     this.pocetChecknutychPredmetov--;
  //   }
  // }

  toggleRiadok(predmet: Predmet) {


  // Ak chcete zabrániť výberu nad max limit:
    if (!predmet.vybrany) {

      if (this.typZobrazovanychDat === this.TYP_DAT_PROFILOVE_PREDMETY) {

        if (this.pocetChecknutychPredmetov() >= this.maxPocetPredmetov) {

            // Voliteľné: Zobraziť nejakú hlášku / toast notification
            this.appStateService.openErrorDialog(
              this.translateService.instant('Maximálny počet vybraných predmetov je') + ' ' + this.maxPocetPredmetov
            );
            return;

        }

      } else {

        if (this.pocetChecknutychProfilovychAOstatnychPredmetov() >= this.maxPocetPredmetov) {

          // Voliteľné: Zobraziť nejakú hlášku / toast notification
          this.appStateService.openErrorDialog(
            this.translateService.instant('Maximálny počet vybraných predmetov je') + ' ' + this.maxPocetPredmetov
          );
          return;

        }

      }

    }

    predmet.vybrany = !predmet.vybrany;

  // Oznámime Signálom zmenu, aby computed() vedel prepočítať novú hodnotu a Angular aktualizoval UI

    if (this.typZobrazovanychDat === this.TYP_DAT_PROFILOVE_PREDMETY) {
      this.predmetyPole.update(list => [...list]);
    } else {
      this.profilovePredmetyPole.update(list => [...list]);
      this.ostatnePredmetyPole.update(list => [...list]);
    }


    // this.prepocitajPocetChecknutychPredmetov();

    // // Simulujeme správanie checkboxu
    // if (!item.vybrany) {
    //   // Ak sa pokúšame zaškrtnúť, overíme maximum
    //   if (this.pocetChecknutychPredmetov >= this.maxPocetPredmetov) {
    //     this.appStateService.openErrorDialog(
    //       this.translateService.instant('Maximálny počet vybraných predmetov je') + ' ' + this.maxPocetPredmetov
    //     );
    //     return;
    //   }
    //   item.vybrany = true;
    //   this.pocetChecknutychPredmetov++;
    // } else {
    //   // Ak odškrtávame
    //   item.vybrany = false;
    //   this.pocetChecknutychPredmetov--;
    // }

  }

  prepocitajPocetChecknutychPredmetov() {
    // Computed signal updates automatically, no action needed
  }


  getNazovPredmetu(predmet: Predmet, kodJazyk): string {

    switch (kodJazyk) {
      case 'EN':
        return predmet.nazovEN;
      case 'HU':
        return predmet.nazovHU;
      default:
        return predmet.nazov;
    }

  }

}
